(() => {
  if (window.nutraToddlerLandingInitialized) return;

  window.nutraToddlerLandingInitialized = true;

  const initializeRetailerSliders = (container = document) => {
    if (!customElements.get('swiper-container')) {
      customElements.whenDefined('swiper-container').then(() => {
        initializeRetailerSliders(container.isConnected ? container : document);
      });
      return;
    }

    const sliders = container.querySelectorAll('.nutra-toddler__retailer-list');

    sliders.forEach((slider) => {
      if (slider.dataset.nutraRetailerSliderInitialized === 'true') return;

      Object.assign(slider, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        pagination: {
          clickable: true,
        },
        breakpoints: {
          768: {
            allowTouchMove: false,
            slidesPerGroup: 2,
            slidesPerView: 2,
            spaceBetween: 48,
          },
        },
      });

      slider.initialize();
      slider.dataset.nutraRetailerSliderInitialized = 'true';
    });
  };

  initializeRetailerSliders();

  document.addEventListener('shopify:section:load', (event) => {
    initializeRetailerSliders(event.target);
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.nutra-toddler__table-toggle');
    if (!toggle) return;

    const tableId = toggle.getAttribute('aria-controls');
    const tableWrap = document.getElementById(tableId);
    if (!tableWrap) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const nextExpandedState = !isExpanded;
    const label = toggle.querySelector('.nutra-toddler__table-toggle-label');

    toggle.setAttribute('aria-expanded', String(nextExpandedState));
    if (label) {
      label.textContent = nextExpandedState
        ? toggle.dataset.expandedLabel
        : toggle.dataset.collapsedLabel;
    }

    tableWrap.classList.toggle('is-expanded', nextExpandedState);
    tableWrap.classList.toggle('is-collapsed', !nextExpandedState);

    if (!nextExpandedState) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      toggle.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
  });
})();
